<div class="voice-modal" style="overflow: auto; padding-top: 20px;">
  <app-button text="Male Voice" (click)="voiceSelection('male')" data-cy='contButton' ></app-button>
  <app-button text="Female Voice" (click)="voiceSelection('female')" data-cy='contButton' ></app-button>
</div>
